const createMuiCheckboxStyles = () => ({
    styleOverrides: {
        root: {
            alignItems: 'flex-start',
            padding: '6px',
            '& + .MuiStack-root, & + div': {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-start',
            },
            '& + .MuiStack-root .MuiFormControlLabel-label, & + div .MuiFormControlLabel-label': {
                order: 2,
            },
            '& + .MuiStack-root .MuiFormControlLabel-asterisk, & + div .MuiFormControlLabel-asterisk':
                {
                    order: 1,
                    paddingTop: '18px',
                },
        },
    },
});

export default createMuiCheckboxStyles;
